import { useTranslation } from "react-i18next";
import { Chip, TableCell } from "@mui/material";

import { StatusCellProps } from "../../../../payment.types";
import { FailedStatusIcon, SuccessStatusIcon } from "../../../../../../assets/icons/MUI/PaymentIcons";

export const StatusCell = ({ status }: StatusCellProps) => {
  const { t } = useTranslation();

  return (
    <TableCell
      sx={{
        textAlign: "center",
        fontFamily: "Montserrat",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "18px",
        position: "relative",
      }}
    >
      {status === "success" ? (
        <SuccessStatusIcon
          sx={{
            position: "absolute",
            top: "50%",
            left: "0",
            transform: "translateY(-50%)",
          }}
        />
      ) : (
        <FailedStatusIcon />
      )}
      <Chip
        label={t(`pages.payment.paymentLinks.${status}`)}
        sx={{
          paddingRight: "20px",
          height: "22px",
          background: "transparent",
          "& .MuiChip-label": {
            padding: "0 8px",
            background: status === "fail" ? "var(--Error-50, #FEF3F2)" : "var(--Success-50, #ECFDF3)",
            color: status === "fail" ? "var(--Error-700, #B42318)" : "var(--Success-700, #027A48)",

            borderRadius: "16px",
            border: "none",
          },
        }}
      />
    </TableCell>
  );
};
